import { apiClient } from '../lib/apiClient';
import { DashboardMetrics, AttendanceData } from '../data/mockData';

export const dashboardService = {
    async getMetrics(): Promise<DashboardMetrics> {
        return apiClient<DashboardMetrics>('/dashboard/metrics');
    },
    async getAttendanceChart(): Promise<AttendanceData[]> {
        return apiClient<AttendanceData[]>('/dashboard/attendance');
    },
};
